"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonInputFile = void 0;
const React = require("react");
const form_utils_1 = require("../../../utils/form.utils");
const BronsonInputFile = (props) => {
    const { accept, defaultValue, noFileText } = props;
    const [fileName, setFileName] = React.useState();
    React.useEffect(() => {
        setFileName(defaultValue ? defaultValue.toString() : noFileText);
    }, [defaultValue]);
    const onChange = (event) => {
        const file = event.target.files[0];
        const types = (accept && accept.split(',')) || [];
        setFileName(file.name);
        if ((types.includes(file.type) || !props.accept) && props.onChange)
            props.onChange(event);
    };
    return (React.createElement(React.Fragment, null,
        props.label && (0, form_utils_1.renderLabel)(props.label, props.validations),
        React.createElement("div", { className: 'o-layout o-layout--equal-height u-mb' },
            React.createElement("div", { style: { position: 'relative', overflow: 'hidden' }, className: `o-layout__item u-1/3 ${props.wrapperClassModifier
                    ? props.wrapperClassModifier
                    : ''}` },
                React.createElement("div", { style: { position: 'relative', overflow: 'hidden' }, className: 'c-btn c-btn--small  c-btn--simple' },
                    React.createElement("input", Object.assign({ id: (0, form_utils_1.generateElementId)(props.elementId), style: { position: 'absolute', opacity: '0' }, type: 'file', onChange: (event) => {
                            onChange(event);
                        }, defaultValue: props.defaultValue || undefined, disabled: props.isDisabled }, (accept ? { accept } : {}))),
                    React.createElement("span", null, props.buttonTitle))),
            React.createElement("div", { className: 'o-layout__item u-2/3' },
                React.createElement("label", { className: 'u-text' }, fileName)))));
};
exports.BronsonInputFile = BronsonInputFile;
